import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, insideImages } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      setIndex(Math.max(0, Math.min(insideImages.length - 1, i)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-98" data-mp="a2o3oog3rxft">
      <div className="mx-auto max-w-2xl" data-id="element-99" data-mp="a139izxpagih">
        <h2 className="text-center font-display text-[1.55rem] font-extrabold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-100" data-mp="612upe6ow3aw">
          LOOK <span className="text-aqua" data-id="element-101" data-mp="jzsskw1c270b">INSIDE</span>
        </h2>
        <p className="mt-1 text-center font-display text-[0.8rem] font-extrabold uppercase text-sun sm:text-[0.95rem]" data-id="element-102" data-mp="f1r8q8w323ns">
          See POOL &amp; SPA DIAGNOSTIC PRO™ In Action
        </p>
        <p className="mt-1 text-center text-[0.78rem] leading-[1.35] text-white/80 sm:text-[0.9rem]" data-id="element-103" data-mp="3nf7ypm6lbwg6">
          Take a look inside the system and see the equipment diagrams, pump troubleshooting references,
          filtration diagnostic charts, heater fault workflows, spa equipment checklists, repair decision
          trees and ready-to-use professional service resources included.
        </p>

        <div className="relative mt-2" data-id="element-104" data-mp="34oqc7zccpx39">
          <div ref={trackRef} className="flex snap-x snap-mandatory overflow-x-auto rounded-lg border-2 border-aqua bg-white [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="group" aria-roledescription="carousel" aria-label="Interior pages of Pool & Spa Diagnostic Pro" tabIndex={0} data-id="element-105" data-mp="2zsrqykmbkv72">
            {insideImages.map((img, i) => <a key={img.src} href={PURCHASE_ANCHOR} className="flex w-full shrink-0 snap-center items-center" aria-label={`Page ${i + 1} of ${insideImages.length} — get the complete system`} data-id="element-106" data-mp="1hicrdq1f6e22" data-mpi={i}>
                <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto w-full bg-white" data-id="element-107" data-mp="tp4azwwpaa8s" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1.5 top-1/2 -translate-y-1/2 rounded-full border-2 border-aqua bg-navy/90 p-1.5 text-aqua shadow-md transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-30" data-id="element-108" data-mp="2a4e71riu8y01">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-109" data-mp="26hpgmzyg2okj" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-full border-2 border-aqua bg-navy/90 p-1.5 text-aqua shadow-md transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-30" data-id="element-110" data-mp="21icygsiiq5oa">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-111" data-mp="3lxy1wy80cx92" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-1.5" data-id="element-112" data-mp="3hw32y0djuvyg">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-[width,background-color] duration-150 ease-out ${i === index ? 'w-5 bg-aqua' : 'w-1.5 bg-navy-line'}`} data-id="element-113" data-mp="3p0ugogyukz5q" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}